import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faChartNetwork } from '@fortawesome/pro-light-svg-icons/faChartNetwork'

export const ETH_METHODS: Array<string> = [
  'eth_accounts',
  'eth_blockNumber',
  'eth_call',
  'eth_chainId',
  'eth_compileSolidity',
  'eth_createAccessList',
  'eth_compileLLL',
  'eth_compileSerpent',
  'eth_estimateGas',
  'eth_feeHistory',
  'eth_gasPrice',
  'eth_getBalance',
  'eth_getBalanceValues',
  'eth_getBlockByHash',
  'eth_getBlockByNumber',
  'eth_getBlockTransactionCountByHash',
  'eth_getBlockTransactionCountByNumber',
  'eth_getBlockSupplyChainByNumber',
  'eth_getCode',
  'eth_getCompilers',
  'eth_getLogs',
  'eth_getProof',
  'eth_getRootHash',
  'eth_getStorageAt',
  'eth_getTransactionByBlockHashAndIndex',
  'eth_getTransactionByBlockNumberAndIndex',
  'eth_getTransactionByHash',
  'eth_getTransactionCount',
  'eth_getTransactionReceipt',
  'eth_getUncleByBlockHashAndIndex',
  'eth_getUncleByBlockNumberAndIndex',
  'eth_getUncleCountByBlockHash',
  'eth_getUncleCountByBlockNumber',
  'eth_getWork',
  'eth_hashrate',
  'eth_maxPriorityFeePerGas',
  'eth_mining',
  'eth_protocolVersion',
  'eth_sendRawTransaction',
  'eth_sendProtectedTransaction',
  'eth_cancelProtectedTransaction',
  'eth_getProtectedTransactionSubmissions',
  'eth_getProtectedTransactionCount',
  'eth_submitWork',
  'eth_syncing',

  // filters methods
  'eth_getFilterChanges',
  'eth_getFilterLogs',
  'eth_newBlockFilter',
  'eth_newFilter',
  'eth_uninstallFilter',
  // end filter methods

  'net_listening',
  'net_peerCount',
  'net_version',

  // subscription methods
  'eth_subscribe',
  'eth_unsubscribe',
  // end subscription methods

  // trace methods
  'trace_block',
  'trace_call',
  'trace_callMany',
  'trace_filter',
  'trace_transaction',
  // end trace methods

  'debug_traceCall',
  'debug_traceBlockByHash',
  'debug_traceBlockByNumber',
  'debug_traceTransaction',

  'web3_clientVersion',
  'web3_sha3',
  'eth_submitHashrate',
  'parity_subscribe',
  'parity_unsubscribe'
]

export const ITX_METHODS: Array<string> = ['relay_sendTransaction', 'relay_getTransactionStatus', 'relay_getBalance']

export const STARKNET_METHODS: Array<string> = [
  'starknet_getStateUpdate',
  'starknet_getNonce',
  'starknet_getBlockWithTxHashes',
  'starknet_getBlockWithTxs',
  'starknet_getStorageAt',
  'starknet_getTransactionByBlockIdAndIndex',
  'starknet_getBlockTransactionCount',
  'starknet_pendingTransactions',
  'starknet_getTransactionByHash',
  'starknet_getTransactionReceipt',
  'pathfinder_getTransactionStatus',
  'starknet_getClass',
  'starknet_getClassHashAt',
  'starknet_getClassAt',
  'starknet_call',
  'starknet_blockNumber',
  'starknet_blockHashAndNumber',
  'starknet_chainId',
  'starknet_syncing',
  'starknet_getEvents',
  'starknet_addInvokeTransaction',
  'starknet_addDeployTransaction',
  'starknet_addDeployAccountTransaction',
  'starknet_addDeclareTransaction',
  'starknet_estimateFee'
]

export const LINEA_METHODS = ['linea_estimateGas']

export const POLYGON_METHODS = [
  'bor_getAuthor',
  'bor_getCurrentProposer',
  'bor_getCurrentValidators',
  'bor_getRootHash',
  'bor_getSignersAtHash'
]

export const NFT_METHODS: Array<string> = [
  'nft_api_collection_metadata',
  'nft_api_collection_nfts',
  'nft_api_collections_assets',
  'nft_api_nft_assets',
  'nft_api_nft_metadata',
  'nft_api_assets_transfers',
  'nft_api_nft_transfers',
  'nft_api_collection_owners',
  'nft_api_nft_owners',
  'nft_api_nft_owners',
  'nft_api_collection_lowest_price'
]

export const ALL_METHODS = [...ETH_METHODS, ...STARKNET_METHODS, ...LINEA_METHODS, ...POLYGON_METHODS]

export type InfuraNetwork = {
  icon: IconDefinition
  text: string
  value: string
  id: string
  isSelected?: boolean
  description: string
}

export const InfuraNetworks: Array<InfuraNetwork> = [
  {
    description: "Ethereum, L2's, and non- evm l1's",
    icon: faChartNetwork,
    id: '1',
    isSelected: true,
    text: 'Ethereum',
    value: 'ethereum'
  },
  { description: 'Distributed, peer-to-peer storage', icon: faChartNetwork, id: '2', text: 'IPFS', value: 'ipfs' }
]

export const ITX_DEPRECATION_DATE = 946684800

export const MOCK_DISCORD_USERNAME = 'dismissed'
export const QA_MAILSOUR_EMAIL_DOMAIN = '@oss1d5xx.mailosaur.net'

export const EMAIL_DOMAIN = 'infura.io'

// Internal Routes
export const BILLING_PLAN_ROUTE = '/billing/plan'
export const BILLING_INVOICES_ROUTE = '/billing/invoices'
export const BILLING_PAYMENT_DETAILS_ROUTE = '/billing/payment-details'
export const BILLING_USAGE_ROUTE = '/billing/usage'

export const STATS_ROUTE = '/dashboard/stats'

export const LOGIN_METHOD_NAME = 'login.method.name'

export const CHART_COLORS = ['#8b99ff', '#B864F5', '#64993D', '#F66A0A', '#FFC70A', '#848C96']
